export default __webpack_public_path__ + "static/media/29.0005c305.jpg";